module.exports = __webpack_public_path__ + "static/img/manual-12.a13c908.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-12.png
// module id = udBG
// module chunks = 4